/**
 * The invite link's token, read from the URL fragment (`#token=ACPI.…`, as the
 * cloud's `invites/inviteToken.ts` builds the link). Null when the page was
 * opened without one.
 */
export function inviteTokenFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('token')?.trim() ?? '';
  return token === '' ? null : token;
}
